module.exports = __webpack_public_path__ + "static/media/image_32.2ba3d488.png";